import { IFraction } from '../../models/Fraction.model';
import { OrderFilterService } from '../../services/filterService';
import { IOrderOverviewFilter } from '../orderOverview/OrderOverview';

export interface StoredCalendarView {
  userName: string;
  view: string;
}

export const filterByDropdowns = (
  orders: Array<any>,
  orderOverviewFilter: IOrderOverviewFilter
): Array<any> => {
  let allOrder = orders;
  if (orderOverviewFilter.fractionIds.length > 0) {
    const filteredOrdes: Array<any> = [];
    orderOverviewFilter.fractionIds.forEach((fractionId) => {
      allOrder.forEach((order) => {
        if (
          order.fractions.some(
            (fraction: IFraction) => fraction.fractionId === fractionId
          ) &&
          !filteredOrdes.some(
            (filteredOrder) => filteredOrder.orderId === order.orderId
          )
        ) {
          filteredOrdes.push(order);
        }
      });
      allOrder = filteredOrdes;
    });
  }
  if (orderOverviewFilter.contractorIds.length > 0) {
    const orders = allOrder.filter((order) =>
      orderOverviewFilter.contractorIds.includes(order.contractorId)
    );
    allOrder = orders;
  }
  if (orderOverviewFilter.statusIds.length > 0) {
    const orders = allOrder.filter((order) => {
      return orderOverviewFilter.statusIds.includes(
        order.orderStatus.orderStatusId
      );
    });
    allOrder = orders;
  }
  if (orderOverviewFilter.routeIds.length > 0) {
    const orders = allOrder.filter((order) => {
      return orderOverviewFilter.routeIds.includes(order.routeData.name);
    });
    allOrder = orders;
  }
  const filteredOrders = OrderFilterService.filter(allOrder);
  return filteredOrders;
};

function getStoredCalendarViews(): Array<StoredCalendarView> {
  const calendarViews = localStorage.getItem('calendarView');
  if (calendarViews) {
    const calendarViewArray: Array<StoredCalendarView> =
      JSON.parse(calendarViews);
    return Array.isArray(calendarViewArray) ? calendarViewArray : [];
  } else {
    return [];
  }
}

export function setDefaultCalendarView(userName: string, view: string): void {
  const storedViews = getStoredCalendarViews();
  if (storedViews.length) {
    const userIndex = storedViews.findIndex((e) => e.userName === userName);
    if (storedViews[userIndex]) {
      storedViews[userIndex].view = view;
    } else {
      storedViews.push({ userName, view });
    }
  } else {
    storedViews.push({ userName, view });
  }
  localStorage.setItem('calendarView', JSON.stringify(storedViews));
}

export function getDefaultCalendarView(): string {
  const userName = localStorage.getItem('userName');
  const storedViews = getStoredCalendarViews();
  if (storedViews.length) {
    const userIndex = storedViews.findIndex((e) => e.userName === userName);
    if (storedViews[userIndex]) {
      return storedViews[userIndex].view;
    }
  }
  return 'work-week';
}

export function getCalendarFromdate(today: Date, calendarView: string): Date {
  if (calendarView === 'month') {
    return new Date(today.getFullYear(), today.getMonth(), -4, 12);
  } else if (calendarView === 'week') {
    return getWeekRange(today, false).firstDay;
  } else {
    return getWeekRange(today, true).firstDay;
  }
}

export function getCalendarTodate(today: Date, calendarView: string): Date {
  if (calendarView === 'month') {
    return new Date(today.getFullYear(), today.getMonth() + 1, 7, 12);
  } else if (calendarView === 'week') {
    return getWeekRange(today, false).lastDay;
  } else {
    return getWeekRange(today, true).lastDay;
  }
}

export function getWeekRange(today: Date, isWorkWeek: boolean): any {
  const dayOfWeek = today.getDay();

  const firstDay = new Date(today);
  firstDay.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

  const lastDay = new Date(firstDay);
  lastDay.setDate(firstDay.getDate() + (isWorkWeek ? 4 : 6));

  return {
    firstDay,
    lastDay,
  };
}
